import React from "react";
export function UploaderScroller({ image, handleScale, maxValue }) {
  return (
    <div className="logo-selector-scroller">
      <input
        className="input-slider"
        name="scale"
        type="range"
        onChange={handleScale}
        min="1"
        max={maxValue}
        step="0.01"
        defaultValue="1"
      />
    </div>
  );
}
